import Vue from 'vue'
import http from '@/utils/http-common'
import { createCSIssueApi } from './cs-issue-api-adapter.mjs'
import { createCSIssueRepository } from './cs-issue-api-repository.mjs'

export const csIssueRepository = createCSIssueRepository(createCSIssueApi(http), Vue.observable)

export function openCSIssueDraft(router, source, payload = {}) {
  const draft = csIssueRepository.createDraft(source, payload)
  return router.push({ name: 'CSIssueCreate', query: { draft } }).catch(() => {})
}
